let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("48eS0")).then(() => parcelRequire('ypOne'));